// useFitText.js
import { useEffect, useRef, useState } from 'react';

export const useFitText = ({ minFontSize = 12, maxFontSize = 28, resolution = 1 } = {}) => {
  const ref = useRef(null);
  const [fontSize, setFontSize] = useState(maxFontSize);

  useEffect(() => {
    const resizeText = () => {
      const el = ref.current;
      if (!el) return;

      let currentSize = maxFontSize;
      el.style.fontSize = `${currentSize}px`;

      while (
        (el.scrollHeight > el.offsetHeight || el.scrollWidth > el.offsetWidth) &&
        currentSize > minFontSize
      ) {
        currentSize -= resolution;
        el.style.fontSize = `${currentSize}px`;
      }

      setFontSize(currentSize);
    };

    resizeText();
    window.addEventListener('resize', resizeText);
    return () => window.removeEventListener('resize', resizeText);
  }, [maxFontSize, minFontSize, resolution]);

  return { ref, fontSize };
};
